import RateReviewIcon from "@mui/icons-material/RateReview";
import useExcelUrl from "app/useExcelUrl";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import ReviewPartnerForm from "./ReviewPartnerForm";
import { ReviewPartnerItem } from "./reviewPartnerApi";
import useReviewPartnerList from "./useReviewPartnerList";

export interface ReviewPartnerListProps
  extends Omit<DataGridBaseBaseProps, "id"> {
  showHeader?: boolean;
}

export default function ReviewPartnerList({
  showHeader = true,
  ...props
}: ReviewPartnerListProps) {
  const { params, scope, editUrl, ...service } = useReviewPartnerList();
  const { hasPermissions, canEditItem } = useAccess();
  const excelUrl = useExcelUrl("review-partners");

  let columns: GridColumns<ReviewPartnerItem> = [
    {
      field: "name",
      headerName: I18n.t("ReviewPartner.attributes.name"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<RateReviewIcon />}
          title={I18n.t("ReviewPartner.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="review-partners"
        excelUrl={excelUrl}
        renderModalForm={props => <ReviewPartnerForm {...props} />}
        modalProps={{ maxWidth: "sm" }}
        {...props}
        canCreate={hasPermissions("review_partner.create")}
        canDelete={hasPermissions([
          "review_partner.editany",
          "review_partner.editown",
        ])}
        canEdit={hasPermissions([
          "review_partner.editany",
          "review_partner.editown",
        ])}
        canDeleteRow={params => canEditItem("review_partner", params.row)}
        canEditRow={params => canEditItem("review_partner", params.row)}
        canBatchActions={hasPermissions([
          "review_partner.editany",
          "review_partner.editown",
        ])}
        canHandleTrash={hasPermissions([
          "review_partner.editany",
          "review_partner.editown",
        ])}
      />
    </>
  );
}
